import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F6F6F6" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>How Much Does Developing an Ecommerce App Really Cost?</h2>
            <p>
              Ecommerce application development is a lot more complex as
              compared to other kinds of application development since it has a
              lot of variables you need to account for. Here are the major ones
              among them:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get your Ecommerce App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Advanced or Basic</h4>
                  <p>
                    The Ecommerce app you want to get developed can either be
                    very basic and rudimentary in nature or if you are opting
                    for a large scale, highly custom digital marketplace, then
                    you will need an advanced level app. For basic apps, the
                    cost will be relatively low but for more advanced level
                    apps, the costs can be quite high.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>iOS or Android</h4>
                  <p>
                    The cost of your Ecommerce app will vary depending on which
                    platform you want it for. Each platform has a different
                    development cost and you need to give a high amount of
                    weightage to this factor.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Hyrbrid or Native App Development</h4>
                  <p>
                    Native apps are much more sustainable than Hybrid apps but
                    their costs are also quite high as compared to the later.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Feature Integration</h4>
                  <p>
                    Specialized features like chat bot integration or social
                    login can affect the cost of the app greatly and if the list
                    of such features grows, then the overall app cost will also
                    grow. If you want to get a round-off estimate on your app
                    costs, then you can check it out on our app calculator here.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
